<template>
<div>
    <section class="container mt-3 py-3">
        <h4 class="mb-4">TreeView</h4>
        <tree
            :data="items"
            :options="options"
            ref="tree"
            v-model="selectedItems"
        />

        <pre class="bg-light px-3" v-if="selectedItems && selectedItems.checked"> {{ selectedItems.checked.map(el => el.data) }} </pre>
        
        <p class="mb-0 mt-4">Codigo de ejemplo para la implementación de treeview</p>
        <div v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup">
    <tree
        :data="items"
        :options="options"
        ref="tree"
        v-model="selectedItems"
    />
    </script></code></pre></div>
        <!-- <div class="p-3 bg-white">
            <code class="text-dark" v-text="htmlvalue"> </code> <br>
            <code>
                :data="items" <br>
                :options="options" <br>
                ref="tree" <br>
                v-model="selectedItems"
            </code> <br>
            <code class="text-dark" v-text="htmlvalue2"> </code>

        </div> -->
        
        <p class="mb-0 mt-3">Opciones del componente</p>
        <table class="table" style="font-size:.8rem;">
            <thead>
                <tr>
                <th width="20%" scope="col">Propiedad</th>
                <th scope="col">Tipo</th>
                <th scope="col">Descripción</th>
                </tr>
            </thead>
            <tbody class="table-group-divider">
                <tr v-for="(desc, index) in descripcion" :key="index">
                <th width="20%" scope="row"> <code>{{desc.propiedad}}</code> </th>
                <td style="font-size:.7rem;">{{desc.tipo}}</td>
                <td>{{desc.descripcion}}</td>
                </tr>
            </tbody>
        </table>

        <p class="text-dark mt-5 mb-0">Ejemplo del script que arma el arbol mostrado previamente.</p>
        <div class="accordion" id="accordionExample">
            <div class="accordion-item body-3 montserrat-400">
                <h2 class="accordion-header" id="headingTwo">
                    <button 
                        class="accordion-button surface collapsed body-2 montserrat-400" 
                        type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" 
                        aria-expanded="false" aria-controls="collapseTwo"> Ver Json de muestra para treeview
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" 
                    aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                    <div class="accordion-body p-0">
                        <p class="mb-0 pt-2 ps-5 bg-light border-bottom">Codigo Javascript</p>
        <div v-highlight class="mb-5">
        <pre class="language-javascript p-0"><code>
    export default {
        data(){
            return{
                items: [
                    { 
                        text: 'Item 1', 
                        data:{id:1232,desc:"prueba"},
                        state: { checked: false } 
                    },
                    { 
                        text: 'Item 2', 
                        data: null
                    },
                    { 
                        text: 'Item 3',
                        state: { checked: true },
                        children: [
                            { 
                                text: 'Item 3.1'
                            },
                            { 
                                text: 'Item 3.2'
                            },
                        ]
                    },
                    { 
                        text: 'Item 4' 
                    },
                    { 
                        text: 'Item 5', children: [
                            { 
                                text: 'Item 5.1'
                            },
                            { 
                                text: 'Item 5.2', state: { selectable: false } 
                            },
                        ]
                    }
                ],
                options: {
                    checkbox: true,
                    checkOnSelect: true
                },
                selectedItems:[]
            }
        }
    }</code></pre>
        </div>
                        <!--  -->
                    </div>
                </div>
            </div>
        </div>
        
        <small>Para más información visitar sitio oficial <a target="_blank" href="https://amsik.github.io/liquor-tree/">Liquor Tree</a></small>
        
        <!-- CODIGO HTML -->
        <!-- <pre><textarea style="height:997px;" readonly>
    <script>
        
    </script>
        </textarea></pre> -->


    </section>
</div>

</template>
<script>
export default {
    name:'PxTreeViewComponent',
    created(){
        window.scrollTo(0, 0);
    },
    data(){
        return{
            items: [
                { 
                    text: 'Item 1', 
                    data:{id:1232,desc:"prueba"},
                    state: { checked: false } 
                },
                { 
                    text: 'Item 2', 
                    data: null
                },
                { 
                    text: 'Item 3',
                    state: { checked: true },
                    children: [
                        { 
                            text: 'Item 3.1'
                        },
                        { 
                            text: 'Item 3.2'
                        },
                    ]
                },
                { 
                    text: 'Item 4' 
                },
                { 
                    text: 'Item 5', children: [
                        { 
                            text: 'Item 5.1'
                        },
                        { 
                            text: 'Item 5.2', state: { selectable: false } 
                        },
                    ]
                }
            ],
            options: {
                checkbox: true,
                checkOnSelect: true
            },
            selectedItems:[],


            // componente externo
            htmlvalue: '<tree',
            htmlvalue2: ' />',

            descripcion: [
                {'propiedad': ':data', 'tipo': 'array de objetos', 'descripcion': 'Array de objetos con items de treeview.'},
                {'propiedad': ':options', 'tipo': 'objeto', 'descripcion': 'Define el comportamiento del arbol, configurable.'},
                {'propiedad': 'ref', 'tipo': 'string', 'descripcion': 'Es una referencia del componente.'},
                {'propiedad': 'v-model', 'tipo': 'Array', 'descripcion': 'Guarda los elementos seleccionados del arbol.'}
            ]

        }
    }
}
</script>